import { render, staticRenderFns } from "./Home2021.vue?vue&type=template&id=2ec17a41&scoped=true&"
import script from "./Home2021.vue?vue&type=script&lang=js&"
export * from "./Home2021.vue?vue&type=script&lang=js&"
import style0 from "./Home2021.vue?vue&type=style&index=0&id=2ec17a41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec17a41",
  null
  
)

export default component.exports